var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPageNotAvailableLarge = function SvgPageNotAvailableLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "470px",
    height: "229px",
    viewBox: "0 0 470 229",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "not_available_large")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salesforce-Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration_large_not_available",
    transform: "translate(-65.000000, -89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Empty-State-/-z-nested-/-Not-Available-/-Large"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PageNotAvailable"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 600,
    height: 400
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mountain",
    transform: "translate(67.000000, 266.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 36.5,
    x2: 466,
    y2: 36.5,
    id: "HorizonLineBack2",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 36.5,
    x2: 6,
    y2: 36.5,
    id: "HorizonLineBack1",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "MountainLine4",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "43 36 87.5 0 121.5 27"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "MountainLine1",
    stroke: "#C2E8FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "111 17 121.5 9 153 36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.962964,14.4391572 L57,36 L57,36 L45.770218,26.1063642 L49.037036,14.4391572 C49.1859485,13.9073269 49.7377996,13.5969106 50.2696299,13.7458231 C50.6059625,13.8399963 50.8687909,14.1028246 50.962964,14.4391572 Z",
    id: "MountainTree",
    fill: "#C2E8FF",
    transform: "translate(51.385109, 24.626882) scale(-1, 1) translate(-51.385109, -24.626882) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tree2",
    transform: "translate(451.500000, 238.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree2White",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9209988,1.95433401 L33.259296,51.443436 C33.5666778,52.5043744 32.9557995,53.613617 31.8948612,53.9209988 C31.7139843,53.9734036 31.5266126,54 31.3382972,54 L2.6617028,54 C1.5571333,54 0.661702805,53.1045695 0.661702805,52 C0.661702805,51.8116846 0.688299176,51.6243129 0.74070397,51.443436 L15.0790012,1.95433401 C15.386383,0.893395645 16.4956256,0.282517358 17.556564,0.589899164 C18.2152102,0.780726338 18.7301717,1.29568777 18.9209988,1.95433401 Z",
    id: "Tree2WhiteBkgd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tree2LightBlue",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Tree2LightBlueOutline1",
    strokeLinejoin: "round",
    points: "17 0.323943662 34 54 -1.8172e-12 54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,4.6953125 C17,43.0456294 17,62.6471919 17,63.5 C17,62.6471919 17,43.0456294 17,4.6953125 Z",
    id: "Tree2LightBlueLine2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,29.3239437 C22.3333333,35.7851611 25,39.1184944 25,39.3239437 C25,39.1184944 22.3333333,35.7851611 17,29.3239437 Z",
    id: "Tree2LightBlueLine1",
    strokeLinejoin: "round",
    transform: "translate(21.000000, 34.323944) scale(-1, 1) translate(-21.000000, -34.323944) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tree1",
    transform: "translate(408.000000, 205.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree1White",
    transform: "translate(1.000000, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6478873,0 L50.879042,84.4273253 C51.1953215,85.4856452 50.5937789,86.5999782 49.535459,86.9162577 C49.3496374,86.9717906 49.1567264,87 48.9627843,87 L2.33299037,87 C1.22842087,87 0.332990367,86.1045695 0.332990367,85 C0.332990367,84.8060578 0.361199757,84.6131469 0.416732643,84.4273253 L25.6478873,0 L25.6478873,0 Z",
    id: "Tree1WhiteBkgd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tree1LightBlue",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Tree1LightBlueOutine",
    strokeLinejoin: "round",
    points: "26.5 0 52.5 87 0.5 87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,3.58642578 C26.5,64.0261034 26.5,94.9972948 26.5,96.5 C26.5,94.9972948 26.5,64.0261034 26.5,3.58642578 Z",
    id: "Tree1LightBlueLine3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6478873,42 C22.9812207,49.078692 26.6478873,52.7453587 26.6478873,53 C26.6478873,52.7453587 22.9812207,49.078692 15.6478873,42 Z",
    id: "Tree1LightBlueLine2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6478873,68 C36.9812207,57.078692 41.6478873,51.7453587 41.6478873,52 C41.6478873,51.7453587 36.9812207,57.078692 27.6478873,68 Z",
    id: "Tree1LightBlueLine1",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Axe",
    transform: "translate(323.317280, 164.835938) rotate(-45.000000) translate(-323.317280, -164.835938) translate(242.317280, 130.835938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AxeWhite",
    transform: "translate(5.000000, 44.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.18947979,0.995611783 L0.115234375,11.9555255 C12.0957996,19.4577143 18.3338849,23.301537 18.8294904,23.4869936 C19.1669204,23.6132606 21.7612542,24.0399819 26.9701953,23.7763273 C28.5980425,23.6939326 31.6346656,23.3623612 36.0800647,22.7816131 C40.0461992,21.6828201 43.0275796,20.7161876 45.0242059,19.8817158 C47.0208321,19.0472439 50.3465588,17.377878 55.0013859,14.8736182 L47.5277368,3.21878589 L4.18947979,0.995611783 Z",
    id: "AxeEdge"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AxeLightBlue",
    transform: "translate(1.000000, 0.000000)",
    fill: "#C2E8FF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "HandleShortBkgd",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 0.973240311,
    y: 10.995821,
    width: 11.5,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.77755146,50.2284782 C13.286202,52.6362568 21.480957,53.7936597 29.3618164,53.7006867 C37.2426758,53.6077138 44.7765582,51.7400968 51.9634637,48.0978356 C50.0751252,44.4670451 48.7826758,41.7898449 48.0861155,40.0662351 C47.3895551,38.3426252 46.5236255,35.6790055 45.4883267,32.075376 L45.2946319,0.293204959 L12.5695367,0.148192827 L12.5726441,32.0166806 C11.5738974,36.4623212 10.6196945,39.7477667 9.71003558,41.8730172 C8.80037666,43.9982676 7.15621528,46.7834213 4.77755146,50.2284782 Z",
    id: "AxeShapeBkgd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4341011,10.7998275 L160.934101,10.7998275 L160.934101,29.2075859 C138.796894,24.9149057 121.296894,22.8695992 108.434101,23.0716664 C103.947529,23.0716664 96.9638862,23.0716664 87.4831733,23.0716664 L45.4341011,23.0716664 L45.4341011,10.7998275 Z",
    id: "HandleLongBkgd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AxeDarkBlue",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5015145,4.547e-13 L46.505417,4.547e-13 L46.505417,24.0516129 C46.0805407,29.6108858 47.016166,35.1227138 49.312293,40.5870968 C51.6084201,46.0514798 55.1733269,52.064383 60.0070135,58.6258065 C49.5057718,64.6387097 39.5045892,67.6451613 30.0034658,67.6451613 C20.5023423,67.6451613 10.5011597,64.6387097 -8.20017983e-05,58.6258065 C5.7540776,50.5948062 9.47046374,44.581903 11.1490764,40.5870968 C12.8276891,36.5922906 13.6118351,31.0804626 13.5015145,24.0516129 L13.5015145,4.547e-13 Z",
    id: "AxeShapeOutline",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "HandleShort",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 1.97324031,
    y: 10.995821,
    width: 11.5,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4341011,10.7998275 L161.934101,10.7998275 L161.934101,29.2075859 C139.796894,24.9149057 122.296894,22.8695992 109.434101,23.0716664 C104.947529,23.0716664 97.9638862,23.0716664 88.4831733,23.0716664 L46.4341011,23.0716664 L46.4341011,10.7998275 Z",
    id: "HandleLong",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Handle",
    fill: "#8CD3F8",
    points: "66 10.5225806 102 10.5225806 102.162282 23.0225806 66.0542614 22.8973803"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Stump",
    transform: "translate(124.000000, 219.518658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "StumpWhite",
    transform: "translate(117.000000, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "StumpHighlight",
    points: "0.115234375 0.823139211 0.115234375 6.95790484 131.128906 21.124897 131.128906 14.975483"
  })), /*#__PURE__*/React.createElement("g", {
    id: "StumpLightBlue",
    transform: "translate(95.000000, 4.000000)",
    fill: "#C2E8FF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    points: "21.9667969 0.213764211 152.662109 14.9813423 152.662109 65.9637642 160.867188 80.1434517 174.628906 92.3211861 0.63671875 92.3211861 13.7480469 80.1434517 21.9667969 61.2977486"
  })), /*#__PURE__*/React.createElement("g", {
    id: "StumpDarkBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.5,15.4813423 L118.5,61.4813423 C117.921224,71.8381104 115.333984,79.318309 110.738281,83.921938 C106.142578,88.525567 100.896484,92.8787018 95,96.9813423 L271,96.9813423 C264.389323,92.6555667 259.341797,87.3824891 255.857422,81.1621094 C252.373047,74.9417297 250.253906,67.5264029 249.5,58.916129 L249.5,0.481342336 L118.5,15.4813423 Z",
    id: "StumpOutline",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(183.000000, 48.731342) scale(-1, 1) translate(-183.000000, -48.731342) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.928751,76.7784845 L280,97 L280,97 L262,97 L270.071249,76.7784845 C270.275982,76.2655493 270.857768,76.0157027 271.370703,76.2204365 C271.625359,76.3220801 271.827108,76.5238291 271.928751,76.7784845 Z",
    id: "Grass4",
    fill: "#8CD3F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.428751,84.2946136 L287.5,97 L287.5,97 L275.5,97 L280.571249,84.2946136 C280.775982,83.7816784 281.357768,83.5318318 281.870703,83.7365656 C282.125359,83.8382092 282.327108,84.0399581 282.428751,84.2946136 Z",
    id: "Grass3",
    fill: "#8CD3F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4287513,76.7784845 L98.5,97 L98.5,97 L80.5,97 L88.5712487,76.7784845 C88.7759825,76.2655493 89.3577681,76.0157027 89.8707033,76.2204365 C90.1253588,76.3220801 90.3271077,76.5238291 90.4287513,76.7784845 Z",
    id: "Grass2",
    fill: "#8CD3F8",
    transform: "translate(89.500000, 86.998788) scale(-1, 1) translate(-89.500000, -86.998788) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9287513,84.2946136 L82,97 L82,97 L70,97 L75.0712487,84.2946136 C75.2759825,83.7816784 75.8577681,83.5318318 76.3707033,83.7365656 C76.6253588,83.8382092 76.8271077,84.0399581 76.9287513,84.2946136 Z",
    id: "Grass1",
    fill: "#8CD3F8",
    transform: "translate(76.000000, 90.756853) scale(-1, 1) translate(-76.000000, -90.756853) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 96.9813423,
    x2: 370,
    y2: 96.9813423,
    id: "HorizonLine2",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 96.9813423,
    x2: 12,
    y2: 96.9813423,
    id: "HorizonLine1",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.5,14.4813423 L226.5,40.4813423 C226.854167,55.9423134 234.6875,67.6089801 250,75.4813423",
    id: "StumpLine6",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.5,12.4813423 L212.5,51.4813423 C211.329427,75.4461105 226.830078,87.4461105 259.001953,87.4813423",
    id: "StumpLine5",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.5,
    y1: 9.48134234,
    x2: 190.5,
    y2: 96.4813423,
    id: "StumpLine4",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.5,
    y1: 5.48134234,
    x2: 160.5,
    y2: 96.4813423,
    id: "StumpLine3",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.5,4.48134234 L148.5,60.4813423 C148.166667,84.3362203 131.634766,96.2636593 98.9042969,96.2636593",
    id: "StumpLine2",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5,2.48134234 L131.5,54.2203125 C132.691406,76.2363071 124.326172,87.2443044 106.404297,87.2443044",
    id: "StumpLine1",
    stroke: "#8CD3F8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud2",
    transform: "translate(160.000000, 107.000000)",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud2LightBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,17.5 L63,17.5 C62.2789714,12.0723971 64.081543,7.53186978 68.4077148,3.87841797 C73.3754883,-0.195556641 79.2734375,0.717773438 82.440918,2.12353516 C85.6083984,3.52929687 87.9606934,5.46069336 89.5913086,9.10524041 C90.2822266,10.6397351 90.7517904,11.9379883 91,13",
    id: "Cloud2Outline4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,20.5 C84.0558268,16.8461914 86.2227376,14.4572754 89.5007324,13.333252 C94.4177246,11.6472168 99.0800781,13.8925781 100.942383,16.1518555 C102.804687,18.4111328 103.39502,20.2260742 103.746582,22.1201172 C103.980957,23.3828125 104.06543,24.8427734 104,26.5 C108.141764,26.3313802 110.918945,27.1647135 112.331543,29 C114.040039,31.1936035 114.215332,33.817627 113.593018,35.75 C112.970703,37.682373 110.894531,40.5 107,40.5 L28,40.5",
    id: "Cloud2Outline3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 27.5,
    x2: 83.0004985,
    y2: 27.5,
    id: "Cloud2Outline2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 27.5,
    x2: 8,
    y2: 27.5,
    id: "Cloud2Outline1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud1",
    transform: "translate(319.000000, 147.000000)",
    stroke: "#C2E8FF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud1LightBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44,17.5 L63,17.5 C62.2789714,12.0723971 64.081543,7.53186978 68.4077148,3.87841797 C73.3754883,-0.195556641 79.2734375,0.717773438 82.440918,2.12353516 C85.6083984,3.52929687 87.9606934,5.46069336 89.5913086,9.10524041 C90.2822266,10.6397351 90.7517904,11.9379883 91,13",
    id: "Cloud1Outline4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,20.5 C84.0558268,16.8461914 86.2227376,14.4572754 89.5007324,13.333252 C94.4177246,11.6472168 99.0800781,13.8925781 100.942383,16.1518555 C102.804687,18.4111328 103.39502,20.2260742 103.746582,22.1201172 C103.980957,23.3828125 104.06543,24.8427734 104,26.5 C108.141764,26.3313802 110.918945,27.1647135 112.331543,29 C114.040039,31.1936035 114.215332,33.817627 113.593018,35.75 C112.970703,37.682373 110.894531,40.5 107,40.5 L28,40.5",
    id: "Cloud1Outline3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 27.5,
    x2: 83.0004985,
    y2: 27.5,
    id: "Cloud1Outline2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 27.5,
    x2: 8,
    y2: 27.5,
    id: "Cloud1Outline1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Branch",
    transform: "translate(179.000000, 216.518658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BranchWhite",
    transform: "translate(6.000000, 2.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8180195,40.0662428 L20.8180195,3.98882348 C14.8180195,9.37296043 11.8180195,15.3858637 11.8180195,22.0275332 C11.8180195,28.6692027 14.8180195,34.6821059 20.8180195,40.0662428 Z",
    id: "LeafHighLight2",
    transform: "translate(16.318019, 22.027533) scale(-1, -1) rotate(-45.000000) translate(-16.318019, -22.027533) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0732996,21.3284985 L38.0732996,-1.21988855 C34.3232996,2.14519704 32.4482996,5.90326156 32.4482996,10.054305 C32.4482996,14.2053484 34.3232996,17.963413 38.0732996,21.3284985 Z",
    id: "LeafHighLight1",
    transform: "translate(35.260800, 10.054305) scale(1, -1) rotate(-45.000000) translate(-35.260800, -10.054305) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "BranchLightBlue",
    transform: "translate(0.000000, 6.000000)",
    fill: "#C2E8FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8180195,42.0662428 L20.8180195,5.98882348 C14.8180195,11.3729604 11.8180195,17.3858637 11.8180195,24.0275332 C11.8180195,30.6692027 14.8180195,36.6821059 20.8180195,42.0662428 Z",
    id: "LeafBkgd2",
    transform: "translate(16.318019, 24.027533) rotate(-45.000000) translate(-16.318019, -24.027533) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9262378,21.3284985 L47.9262378,-1.21988855 C44.1762378,2.14519704 42.3012378,5.90326156 42.3012378,10.054305 C42.3012378,14.2053484 44.1762378,17.963413 47.9262378,21.3284985 Z",
    id: "LeafBkgd",
    transform: "translate(45.113738, 10.054305) scale(-1, 1) rotate(-45.000000) translate(-45.113738, -10.054305) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "BranchDarkBlue",
    stroke: "#8CD3F8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,64.4813423 C42.5559896,58.4405997 33.7226563,49.4405997 33.5,37.4813423 L33.5,0.481342336",
    id: "BranchLine"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,44.8774194 C25.5,39.4932824 28.5,33.4803792 28.5,26.8387097 C28.5,20.1970402 25.5,14.1841369 19.5,8.8 C13.5,14.1841369 10.5,20.1970402 10.5,26.8387097 C10.5,33.4803792 13.5,39.4932824 19.5,44.8774194 Z",
    id: "Leafbig",
    transform: "translate(19.500000, 26.838710) rotate(-45.000000) translate(-19.500000, -26.838710) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.125,25.3354839 C46.875,21.9703983 48.75,18.2123338 48.75,14.0612903 C48.75,9.91024688 46.875,6.15218236 43.125,2.78709677 C39.375,6.15218236 37.5,9.91024688 37.5,14.0612903 C37.5,18.2123338 39.375,21.9703983 43.125,25.3354839 Z",
    id: "Leafsm",
    transform: "translate(43.125000, 14.061290) scale(-1, 1) rotate(-45.000000) translate(-43.125000, -14.061290) "
  })))))))));
};
export default SvgPageNotAvailableLarge;